import { render } from "./Manual.vue?vue&type=template&id=5ca41d4a"
import script from "./Manual.vue?vue&type=script&lang=js"
export * from "./Manual.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__